import BaseModel from './BaseModel';

class QuestionnaireFilterOption extends BaseModel {}

QuestionnaireFilterOption.collection = 'QuestionnaireFilterOptions';

export default QuestionnaireFilterOption;
